

import axios from "axios";

import { API_URL } from "./conection";

export const getHelp = async () => {
  try {
    const res = await axios.get(`${API_URL}/help`);
    return res.data;
  } catch (error) {
    console.error("Error en getHelp:", error);
    return [];
  }
};
